// Resolution/format tags ("4K", "HD", "1080p", ...) routinely sit between
// "Official" and the video/audio keyword - "[Official 4K Music Video]" -
// so they need to be skippable, not just plain whitespace, between the two.
const QUALITY_TOKEN = '(?:4k|8k|hd|fhd|uhd|hq|1080p|720p|480p|60fps)';
const TAG_KEYWORDS = '(?:lyric(?:s)?\\s*video|music\\s*video|video|audio|lyrics?)';

// YouTube upload titles routinely end in a bracketed tag like
// "(Official Lyric Video)", "[Official Video]" or "(Official Audio)" -
// useful metadata for the uploader, just noise in a search-results list.
// Strips ()/[] tags matching that family off the end, repeatedly (some
// titles stack more than one, e.g. "Song (Official Video) [Lyrics]").
const BRACKETED_TAG_REGEX = new RegExp(`\\s*[([]\\s*(?:official\\s*)?(?:${QUALITY_TOKEN}\\s*)*${TAG_KEYWORDS}\\s*[)\\]]\\s*$`, 'i');

// Same family of tag, but plenty of uploaders never bother with brackets at
// all - "Song Name Official Music Video" or "Song Name - Official Video".
// Anchored on "official" (not just "video"/"audio" alone) since those two
// words alone are far too common in real song titles to safely strip.
const BARE_OFFICIAL_TAG_REGEX = new RegExp(`\\s*[-–—|•]?\\s*official\\s*(?:${QUALITY_TOKEN}\\s*)*${TAG_KEYWORDS}\\s*$`, 'i');

export function cleanMusicTitle(title) {
    let cleaned = String(title);
    let previous;
    do {
        previous = cleaned;
        cleaned = cleaned.replace(BRACKETED_TAG_REGEX, '').replace(BARE_OFFICIAL_TAG_REGEX, '');
    } while (cleaned !== previous);
    return cleaned.trim();
}
